import type { SceneControl } from '@anov/3d-core'
import { OutputPass, lib, use } from '@anov/3d-core'

const { SAOPass } = lib

/**
 * add ssao 环境光遮蔽
 * @returns
 */
const addSAOPass = (sceneControl: SceneControl) => {
  const { scene, camera } = use.useScene(sceneControl)
  const composer = sceneControl.context.storeManagement.get('composer') as lib.EffectComposer | undefined

  if (!scene || !camera)
    throw new Error('scene or camera is not defined,')

  if (!composer)
    throw new Error('composer is not defined, please initPostEffects first')

  const saoPass = new SAOPass(scene, camera)
  composer.addPass(saoPass)

  const outputPass = new OutputPass()
  composer.addPass(outputPass)

  return () => {
    composer.removePass(saoPass)
    composer.removePass(outputPass)
  }
}

export default addSAOPass
